// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget066_wrapper__pSOE_"};